<template>
    <!-- <div class="section-cat-home bg-black " >
        <v-carousel class="vuetify-carousel" continuous :height="75" :show-arrows="true"
        :show-indicators="false" hide-delimiters>
            <v-carousel-item v-for="(itemCat, indexCat) in groupingCat(getGameCategoryList)" >
                <div class="section-cat-list-home d-flex justify-space-between">
                    <div class="card-cat-game" v-for="itemCatDetail in itemCat"  @click="gotoGameList(itemCatDetail);">
                        <div>
                            <div class="text-center">
                                <v-icon color="white">{{ convertImage(itemCatDetail.GAME_CATEGORY_ICON) }}</v-icon>
                            </div>
                            <div class="text-center text-white">
                                {{  itemCatDetail.GAME_CATEGORY_NAME }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-carousel-item>
        </v-carousel>
    </div> -->
    <div class="section-cat-home bg-tran " >
        <div class="vuetify-carousel" continuous :height="75" :show-arrows="true"
        :show-indicators="false" hide-delimiters>
            <!-- <div v-for="(itemCat, indexCat) in groupingCat(getGameCategoryList)" > -->
                <div class="section-cat-list-home d-flex justify-space-between" :style="{width: (70*getGameCategoryList.length) + 50 + 'px'}">
                    <div class="card-cat-game cursor-pointer" v-for="itemCatDetail in getGameCategoryList"  @click="gotoGameList(itemCatDetail);">
                        <div>
                            <div class="text-center">
                                <v-icon color="white">{{ convertImage(itemCatDetail.GAME_CATEGORY_ICON) }}</v-icon>
                            </div>
                            <div class="text-center text-white">
                                {{  itemCatDetail.GAME_CATEGORY_NAME }}
                            </div>
                        </div>
                    </div>
                </div>
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
import Navbar from "@/views/home/navbar";
import CardCart from "@/components/cartCard/CardCart";
import { mapGetters, mapActions } from 'vuex';
export default {
    // name: 'Home',
    components: {
        Navbar,
        CardCart,
    },
    computed: {
        ...mapGetters(['getProducts', 'getGameCategoryList']),
    },
    data() {
        return {
            witdth_current: 0,
        }; 
    }, 
    mounted() { 
        // this.GetGamePage();
        this.witdth_current = window.innerWidth;
        // console.log('CategoryList.vue -> mounted -> this.witdth_current', this.witdth_current)
    },
    methods: {
        ...mapActions(["addCart", "removeCart", "GetGamePage", "setGameCateCurrent"]),
        gotoGameList(itemData) {
            if (this.$route.name == "Mobile Categories with layout") {
                this.setGameCateCurrent(itemData.GAME_CATEGORY_ID)
                this.GetGamePage({GAME_CATEGORY_ID: itemData.GAME_CATEGORY_ID})
            } else {
                // console.log('CategoryList.vue -> gotoGameList -> itemData', this.$route)
                
                this.$router.push({ name: "Mobile Categories with layout" , params: { GAME_CATEGORY_ID: itemData.GAME_CATEGORY_ID } });
            }
        },
        groupingCat(catList) {
            let config_cut_item = 5
            let newCatList = []
            if (catList.length > 0) {
                for (let index in catList) {
                    if (index % config_cut_item == 0) {
                        newCatList.push(catList.slice(index, index + config_cut_item))
                    }
                }
            }
            // console.log('CategoryList.vue -> groupingCat -> newCatList', newCatList)
            return newCatList
        },
        convertImage(image) {
            let mdIconName = ""
            // console.log('CategoryList.vue -> convertImage -> image', image)
            if (image == 'fas fa-spade') {
                mdIconName = "mdi-cards-spade"
            } else if (image == 'fas fa-club') {
                mdIconName = "mdi-cards-club"
            } else if (image == 'fas fa-dice') {
                mdIconName = "mdi-dice-6"
            } else if (image == 'fas fa-bomb') {
                mdIconName = "mdi-bomb"
            } else if (image == 'fas fa-chess') {
                mdIconName = "mdi-chess-queen"
            } else if (image == 'fas fa-rocket') {
                mdIconName = "mdi-rocket"
            } else if (image == 'fas fa-diamond') {
                mdIconName = "mdi-diamond"
            } else if (image == 'fas fa-user-robot') {
                mdIconName = "mdi-robot"
            }  else if (image == 'fas fa-raygun') {
                mdIconName = "mdi-ray-gun"
            } else if (image == 'fas fa-dice-d10') {
                mdIconName = "mdi-dice-d10"
            } else if (image == 'fas fa-dice-d6') {
                mdIconName = "mdi-dice-d6"
            } else if (image == 'fas fa-snake') {
                mdIconName = "mdi-snake"
            } else if (image == 'fas fa-meteor') {
                mdIconName = "mdi-meteor"
            } else {
                mdIconName = "mdi-poker-chip"
            }
            return mdIconName
        },
    }
};
</script>
<style lang="scss" scoped>
.top-categories-img {
    width: 385px;
    min-width: 100%;
    max-width: 100%;

}
.v-carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-cat-game {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2d2d2d;
    border-radius: 10px;
}
@media screen and (min-width: 700px) {
    // .card-cat-game {
    //     width: 100px;
    //     height: 100px;
    // } 
}
.section-cat-home {
    padding: 10px;
    // border-bottom-left-radius: 20px;
    // border-bottom-right-radius: 20px;
}
.section-notice-welcome {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}
</style>
